import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading-spinner"></div>
      <p className="loading-text">Loading</p>
    </div>
  );
};

export default Loading;
